//My Personnal PortFolio 
// #I want to WIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIN //

// Summary And Greeting Section

import emoji from "react-easy-emoji";

const illustration = {
  animated: true
};
 // set to false to use static SVG

const greeting = {
  username: "AmanDev Blockchain",
  title: "Hi all, I'm Amy-bcx alias AmanDev Blockchain ",
  subTitle: emoji(
    "A passionate Junior Blockchain Developer ツ  I am currently looking for an opportunity as a junior dev in Blockchain. I am convinced Blockchain is the future of decentralization. My special interests are React, Node, JavaScript, DeFi and Solidity for Ethereum Smart Contracts."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1YGAnSOKIrld5xwI0DnK132MycpJcAHhw/view?usp=sharing",
  displayGreeting: true // Set false to hide this section, defaults to true
  
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/amy-bcx",
  linkedin: "https://www.linkedin.com/in/bontoux-amandine-243b99195/",
  gmail: "https://mail.google.com/mail/u/0/?view=cm&fs=1&to=amy.bcx@gmail.com&su=SUBJECT&body=Hi+AmanDev&tf=1",
  // gitlab: "https://gitlab.com/",
  facebook: "https://www.facebook.com/AmanDev",
  // medium: "https://medium.com/",
  // stackoverflow: "https://stackoverflow.com/",
  instagram: 'https://www.instagram.com/amybcx.amandev/',
  twitter: 'https://twitter.com/AmandevB',
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "About Me",
  subTitle: "Enthusiastic Junior Blockchain Dev ",
  skills: [
    emoji(
      "⚡ Develop interactive Front end using React and Node JS"
    ),
    emoji(
      "⚡ A YouTube Channel for Blockchain and developing"
    ),
    emoji("⚡ Write articles about Blockchain on Publish0x"),
    emoji(
      "⚡ A Solidity and Etherum Smart- Contract App with NodeJs"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
   
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
 
    {
      skillName: "ganache",
      fontAwesomeClassname: "fab fa-glide"
    },
    {
      skillName: "solidity",
      fontAwesomeClassname: "fab fa-strava"
    },
    {
      skillName: "meta-mask",
      fontAwesomeClassname: "fab fa-maxcdn"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Open Classroom",
      logo: require("./assets/images/openClassroomsLogo.png"),
      subHeader: "Attend HTML, CSS, Python and JavaScript",
      duration: "February 2020 - Sept 2020",
      desc: "Created a React JS Blog.",
      descBullets: [
        "https://amy-bcx.github.io/react-blog"
      ]
    },
    {
      schoolName: "Stendhal Grenoble University",
      logo: require("./assets/images/grenobleLogo.png"),
      subHeader: "Bachelor of French teacher as a Foreign Language (FLE),",
      duration: "September 2015 - July 2016",
      desc:
        " Initiation and instruction of a new complex language to small groups."
    },
    {
      schoolName: "Lyon Jean-Moulin University",
      logo: require("./assets/images/lyonUniLogo.png"),
      subHeader: "Bachelor in English-Japanese LEA (Applied Foreign Language)",
      duration: "September 2010 - January 2015",
      desc: "Develop communication skills in English, Japanese and German",
      descBullets: [
        "Became an English teacher in french middle-school"
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend / Design", //Insert stack or technology you have experience in
      progressPercentage: "60%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "40%"
    },
    {
      Stack: "Programming",
      progressPercentage: "50%"
    }
  ],
  displayCodersrank: true // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    // {
    //  role: "Executive Secretary as a Trainer",
    //  company: "Metax-USA Llc",
    //  companylogo: require("./assets/images/metaxUSA.png"),
    //  date: "February 2020",
    //  desc:
    //    "Following instructions, planning, organising and using my creativity and reactivity to anticipate and enhance the company system.",
    //  descBullets: [
    //      "Cooperation with the IT Department"
    //    ]
    //},
    {
      role: "Receptionist for Emerson Company, then Comap Company and last the French Railway SNCF",
      company: "Penelope, S.A.",
      companylogo: require("./assets/images/penelopeLogo.jpg"),
      date: "October 2017 – January 2020",
      desc:
        "Worked for an American company in English and French",
      descBullets: [
          "Learnt the tele-assistance process, the launchment of ticket for C2C customer service",
          "Used to the engineering environment as a hostess."
        ]
    },
    {
      role: "Substitute English teacher as a foreign language in Middle-School",
      company: "French Academy of Lyon",
      companylogo: require("./assets/images/academieLyonLogo.jpg"),
      date: "March 2015 – December 2017",
      desc:
        "I've conducted internal audit making sure the organization is compliant with the GDPR.",
      descBullets: [
        "Differentiated learning strategies to ensure students full potential",
        "Developed and implemented lesson plans to meet academic, intellectual and social needs of the students",
        "Created and revised classroom assessments"
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  githubConvertedToken: process.env.REACT_APP_GITHUB_TOKEN,
  githubUserName: "amy-bcx", // to view my profile in Contact Section.
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "My Projects",
  subtitle: "Instruction is very important and enabling people to get to developing is even more",
  projects: [
    {
      image: require("./assets/images/WeddSite.png"),
      projectName: "Instagram Gallery-image type react-js website",
      projectDesc: "A Website with Slideshow, a firebase picture Gallery, react-video and audio",
      footerLink: [
        {
          name: "Visit my Website here",
          url: "https://weddingpicture-d7053.web.app/"
        }
              ]
    },
    {
      image: require("./assets/images/SlackClone.png"),
      projectName: "A Chat Slack-Clone react-js website",
      projectDesc: "A whatsapp type using firebase for real-time chat and login to access the channels",
      footerLink: [
        {
          name: "Visit my Slack-Clone here",
          url: "https://slack-clone-aeb78.web.app/"
        }
              ]
    },
    {
      image: require("./assets/images/AmanDevBlog.png"),
      projectName: "My first React JS Blog",
      projectDesc: "A Blog that I coded to show my desire to become a Developper",
      footerLink: [
        
        {
          name: "Visit my Blog here",
          url: "https://amy-bcx.github.io/react-blog"
        }
        //  I can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/amanDevLogo.jpg"),
      projectName: "AmanDev",
      projectDesc: "A YouTube French Channel to become a Developper",
      footerLink: [
        {
          name: "Visit my YouTube Channel here",
          url: "https://www.youtube.com/channel/UCIOd39LhhA5JPJRYF_jNzEw"
        }
              ]
    },
    {
      image: require("./assets/images/solidityLogo.png"),
      projectName: "Solidity & Etherum Smart-Contract",
      projectDesc: "A Solidity & Etherum Smart-Contract App using Ganache, Meta-Mask and Ganache",
      footerLink: [
        {
          name: "Visit my coded Project here",
          url: "https://github.com/amy-bcx/A-Solidity-to-do-List-App"
        }
            ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "",
      subtitle:
        ".",
      image: require("./assets/images/me.png"),
      footerLink: [
        {
          name: "",
          url:
            ""
        },
        {
          name: "r",
          url:
            ""
        },
        {
          name: "",
          url:
            ""
        }
      ]
    },
    {
      title: "",
      subtitle:
        "",
      image: require("./assets/images/me.png"),
      footerLink: [
        {
          name: "",
          url:
            ""
        }
      ]
    },

    {
      title: "",
      subtitle: "",
      image: require("./assets/images/me.png"),
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: ""
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "My Publish0x Blogs",
  subtitle:
    "With Love for Developing cool content, I love writing and teaching others what I have learnt.",

  blogs: [
    {
      url:
        "https://www.publish0x.com/blockchain-le-beaba/blockchain-va-t-il-revolutionner-le-monde-xyvjwgv",
      title: "Is Blockchain going to revolutionnized the world ?",
      description:
        "Read my Articles about it here in French, this article is on Publish0x with other articles to help you grasp the Blockchain concept"
    },
    {
      url: "https://www.publish0x.com/blockchain-le-beaba/satoshi-nakamoto-le-mysterieux-pere-fondateur-du-blockchain-xdrmdgn",
      title: "Who is the founder of Blockchain ?",
      description:
        "The mysterious Satoshi Nakamoto, the founder of Blockchain, who is he? "
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "Let's Talk 👩🏻‍🦰",
  //subtitle: emoji(
  //  ""
  //),

  talks: [
    {
      title: "How Great is React JS to you?",
      subtitle: "Let's share!",
      slides_url: "https://medium.com/@thinkwik/why-reactjs-is-gaining-so-much-popularity-these-days-c3aa686ec0b3",
      event_url: "https://slack-clone-aeb78.web.app/room/YLAjcaQksoj6cO1C9e1V",
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TALKING ABOUT BLOCKCHAIN AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://www.disruptordaily.com/episode-78-un-breaking-supply-chains-using-blockchain-podcast/"
  ],
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me 📲"),
  subtitle:
    "You want ro discuss a project or to hire me? My Inbox is open for y'all.",
  number: "(409) 240 1087",
  email_address: "amy.bcx@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "AmandevB", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
